import { Slide } from "react-awesome-reveal";
import rocket from "../media/rocket.png";
import atom from "../media/atom.png";
import rocket__scroll from "../media/rocket_scroll.png";
import people from "./people";

import "../styles/Team.css";

import TeamCard from "./TeamCard";

function Team() {
  return (
    <div className="intro">
      <div className="intro__landing">
        <div className="header">
          <img src={rocket} alt="rocket" />
          <h1>WELCOME TO OUR TEAM</h1>
          <div className="arrow">
            <img src={rocket} alt="rocket" />
          </div>
        </div>
        <p>
        We are a team of highly motivated young people who are ready to tackle on the challenges of real-world software solutions. With extensive background in web development, design, marketing and managing we possess necessary knowledge that will ensure high quality of our products and professional approach. Our passion and vison is to deliver reliable software and solutions that will help satisfy the needs of our customers and make a statement in the field of web development and marketing. Different backgrounds that make up our team give us necessary knowledge that we can exploit and apply to our projects. Together we hope to achieve great things and deliver unique products that will be representative of our hard work and determination.
        </p>

        <div className="art">
          <Slide direction="left" triggerOnce="true" className="atom1">
            <img src={atom} alt="" />
          </Slide>

          <a href="#team" className="arrow__down">
            <span>Scroll</span>
            <Slide direction="down" triggerOnce="true" className="scroll">
              <img src={rocket__scroll} alt="" />
            </Slide>
          </a>
          <Slide direction="right" triggerOnce="true" className="atom2">
            <img src={atom} alt="" />
          </Slide>
        </div>
      </div>

      <div className="team" id="team">
        <div className="team__inner">
          {people.map((person) => {
            return <TeamCard key={person.name} person={person} />;
          })}
        </div>
      </div>
    </div>
  );
}

export default Team;
